import { useQueryClient } from '@tanstack/react-query'
import { useIamContext } from 'ClientPortal/src/context/IAmContext'
import { useSelectedCustomer } from 'ClientPortal/src/context/SelectedCustomerContext'

export const useSignOut = () => {
    const { signOut: amplifySignOut } = useIamContext()
    const { removeSelectedCustomer } = useSelectedCustomer()
    const queryClient = useQueryClient()

    const signOut = () => {
        removeSelectedCustomer()
        queryClient.removeQueries()
        amplifySignOut()
    }

    return { signOut }
}
